(function () {
  var STORAGE = "chbRitualStudio";

  function boot(root) {
    if (!root || root.getAttribute("data-booted") === "1") return;
    var configNode = root.querySelector("[data-ritual-config]");
    if (!configNode) return;
    var config;
    try { config = JSON.parse(configNode.textContent); }
    catch (error) { return; }
    root.setAttribute("data-booted", "1");
    root.classList.add("is-ready");

    var people = (config.personalities || []).filter(function (person) {
      return person && /^[a-z0-9-]{1,60}$/.test(person.slug || "");
    });
    var bySlug = {};
    people.forEach(function (person) { if (!bySlug[person.slug]) bySlug[person.slug] = person; });

    var quiz = root.querySelector("[data-ritual-quiz]");
    var result = root.querySelector("[data-ritual-result]");
    var inbox = root.querySelector("[data-ritual-inbox]");
    var status = root.querySelector("[data-ritual-status]");
    var form = root.querySelector("[data-ritual-form]");
    var questions = [1, 2, 3].map(function (number) {
      return root.querySelector('[data-ritual-question="' + number + '"]');
    });
    var progressLabel = root.querySelector("[data-ritual-progress-label]");
    var progressBar = root.querySelector("[data-ritual-progress-bar]");
    var nameNode = root.querySelector("[data-ritual-name]");
    var copyNode = root.querySelector("[data-ritual-copytext]");
    var stepsNode = root.querySelector("[data-ritual-steps]");
    var mount = root.querySelector("[data-ritual-mount]");
    var shared = root.querySelector("[data-ritual-shared]");
    var shop = root.querySelector("[data-ritual-shop]");
    var dialog = root.querySelector("[data-ritual-dialog]");
    var dialogImg = root.querySelector("[data-ritual-dialog-img]");
    var dialogLink = root.querySelector("[data-ritual-dialog-link]");
    var state = loadState();
    var view = "quiz";
    var current = null;

    function say(message) {
      if (status) status.textContent = message || "";
    }

    function track(name, params) {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.analyticsProcessingAllowed === "function" && !privacy.analyticsProcessingAllowed()) return;
        var payload = params || {};
        window.dataLayer = window.dataLayer || [];
        var eventPayload = { event: name };
        Object.keys(payload).forEach(function (key) { eventPayload[key] = payload[key]; });
        window.dataLayer.push(eventPayload);
        if (typeof window.gtag === "function") window.gtag("event", name, payload);
      } catch (error) {}
    }

    function loadState() {
      try {
        var parsed = JSON.parse(sessionStorage.getItem(STORAGE) || "null");
        if (!parsed || typeof parsed !== "object") return {};
        return parsed;
      } catch (error) { return {}; }
    }

    function saveState() {
      try { sessionStorage.setItem(STORAGE, JSON.stringify(state)); }
      catch (error) {}
    }

    function clearState() {
      state = {};
      try { sessionStorage.removeItem(STORAGE); } catch (error) {}
    }

    function ritualParam() {
      var value = new URLSearchParams(window.location.search).get("ritual") || "";
      if (!/^[a-z0-9-]{1,60}$/.test(value)) return "";
      return value;
    }

    function writeUrl(slug) {
      var url = new URL(window.location.href);
      if (slug) url.searchParams.set("ritual", slug);
      else url.searchParams.delete("ritual");
      history.replaceState({ ritual: slug || "" }, "", url);
    }

    function shareUrl(slug) {
      var currentUrl = new URL(window.location.href);
      var preview = currentUrl.searchParams.get("preview_theme_id");
      var next = new URL(currentUrl.origin + currentUrl.pathname);
      next.searchParams.set("ritual", slug);
      if (preview) next.searchParams.set("preview_theme_id", preview);
      return next.toString();
    }

    function shareText(person) {
      var pattern = config.sharePattern || "I'm {name}! What's your Crystal Health & Beauty ritual?";
      return pattern.replace("{name}", person.name || "my ritual");
    }

    function findPerson(mood, scent) {
      for (var index = 0; index < people.length; index += 1) {
        if (people[index].mood === mood && people[index].scent === scent) return people[index];
      }
      return null;
    }

    function checked(name) {
      var input = form.querySelector('input[name="' + name + '"]:checked');
      return input ? input.value : "";
    }

    function setChecked(name, value) {
      var input = form.querySelector('input[name="' + name + '"][value="' + value + '"]');
      if (input) input.checked = true;
    }

    function answers() {
      return { mood: checked("mood") || state.mood || "", scent: checked("scent") || state.scent || "", moment: checked("moment") || state.moment || "" };
    }

    function showQuestion(number, announce) {
      view = "quiz";
      current = null;
      quiz.hidden = false;
      result.hidden = true;
      if (inbox) inbox.hidden = true;
      questions.forEach(function (node, index) {
        if (!node) return;
        var on = index + 1 === number;
        node.hidden = !on;
      });
      var back = quiz.querySelector("[data-ritual-back]");
      if (back) back.hidden = number === 1;
      var next = root.querySelector("[data-ritual-next]");
      if (next) next.textContent = number === 3 ? "See my ritual" : "Next";
      if (progressLabel) progressLabel.textContent = "Question " + number + " of 3";
      if (progressBar) {
        progressBar.style.width = Math.round(number / 3 * 100) + "%";
        progressBar.parentNode.setAttribute("aria-valuenow", String(number));
      }
      state.step = number;
      saveState();
      var heading = questions[number - 1] && questions[number - 1].querySelector(".chb-rs__question");
      if (announce && heading) heading.focus();
    }

    function stepsFor(person, moment) {
      var text = (person.steps && person.steps[moment]) || "";
      return String(text).split(/\n+/).map(function (line) { return line.trim(); }).filter(Boolean);
    }

    function showResult(person, moment, mode, fresh) {
      if (!person) return;
      view = "result";
      current = { person: person, moment: moment, mode: mode };
      quiz.hidden = true;
      result.hidden = false;
      if (inbox) inbox.hidden = false;
      if (nameNode) nameNode.textContent = person.name || "";
      if (copyNode) copyNode.textContent = person.description || "";
      if (stepsNode) {
        stepsNode.innerHTML = "";
        stepsFor(person, moment).forEach(function (line) {
          var item = document.createElement("li");
          item.textContent = line;
          stepsNode.appendChild(item);
        });
      }
      if (mount) {
        mount.innerHTML = "";
        var source = root.querySelector('[data-ritual-products="' + person.slug + '"]');
        if (source) mount.appendChild(source.cloneNode(true));
      }
      if (shared) shared.hidden = mode !== "shared";
      if (shop) {
        var added = mount && mount.querySelector("[data-ritual-add]");
        var cardLink = added ? added.closest(".chb-rs__card").querySelector("a[href]") : null;
        var anyLink = mount && mount.querySelector("a[href]");
        var href = (cardLink && cardLink.getAttribute("href")) || (anyLink && anyLink.getAttribute("href")) || config.collectionUrl || "/collections/beauty";
        shop.setAttribute("href", href);
      }
      state.mood = person.mood;
      state.scent = person.scent;
      state.moment = moment;
      state.slug = person.slug;
      state.step = "result";
      state.self = mode === "self";
      saveState();
      writeUrl(person.slug);
      if (fresh) {
        state.completed = true;
        saveState();
        track("beauty_ritual_completed", { ritual: person.slug, mood: person.mood, scent: person.scent, moment: moment });
      }
      if (nameNode) nameNode.focus();
    }

    function goNext() {
      var step = state.step || 1;
      if (view !== "quiz") return;
      var picked = answers();
      if (step === 1 && !picked.mood) { say("Choose an answer to continue."); questions[0].querySelector("input").focus(); return; }
      if (step === 2 && !picked.scent) { say("Choose an answer to continue."); questions[1].querySelector("input").focus(); return; }
      if (step === 3 && !picked.moment) { say("Choose an answer to continue."); questions[2].querySelector("input").focus(); return; }
      say("");
      if (step === 1) {
        if (!state.started) {
          state.started = true;
          track("beauty_ritual_started", {});
        }
        state.mood = picked.mood;
        track("beauty_ritual_question_answered", { question: "craving", answer: picked.mood });
        saveState();
        showQuestion(2, true);
        return;
      }
      if (step === 2) {
        state.scent = picked.scent;
        track("beauty_ritual_question_answered", { question: "scent", answer: picked.scent });
        saveState();
        showQuestion(3, true);
        return;
      }
      state.moment = picked.moment;
      track("beauty_ritual_question_answered", { question: "moment", answer: picked.moment });
      var person = findPerson(picked.mood, picked.scent);
      if (!person) { say("That pairing is not set up yet."); return; }
      showResult(person, picked.moment, "self", true);
    }

    function goBack() {
      if (view === "result") {
        setChecked("mood", state.mood);
        setChecked("scent", state.scent);
        setChecked("moment", state.moment);
        writeUrl("");
        showQuestion(3, true);
        return;
      }
      var step = state.step || 1;
      if (step > 1) showQuestion(step - 1, true);
    }

    function restart() {
      clearState();
      form.reset();
      writeUrl("");
      track("beauty_ritual_restarted", {});
      say("");
      showQuestion(1, true);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var area = document.createElement("textarea");
        area.value = text;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.left = "-999px";
        document.body.appendChild(area);
        area.select();
        try { document.execCommand("copy") ? resolve() : reject(); }
        catch (error) { reject(error); }
        document.body.removeChild(area);
      });
    }

    function messageFor(person) {
      return shareText(person) + " " + shareUrl(person.slug);
    }

    function wrap(context, text, maxWidth) {
      var words = String(text || "").split(/\s+/);
      var lines = [];
      var line = "";
      words.forEach(function (word) {
        var trial = line ? line + " " + word : word;
        if (context.measureText(trial).width > maxWidth && line) {
          lines.push(line);
          line = word;
        } else {
          line = trial;
        }
      });
      if (line) lines.push(line);
      return lines;
    }

    function drawCard(width, height) {
      var canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      var context = canvas.getContext("2d");
      var gradient = context.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#fff9f6");
      gradient.addColorStop(1, "#f7e8ec");
      context.fillStyle = gradient;
      context.fillRect(0, 0, width, height);
      context.fillStyle = "#67384f";
      context.beginPath();
      context.arc(width - 120, 160, 180, 0, Math.PI * 2);
      context.globalAlpha = 0.12;
      context.fill();
      context.globalAlpha = 1;
      context.fillStyle = "#b68b48";
      context.fillRect(120, height > 1400 ? 280 : 180, 160, 4);
      context.fillStyle = "#93546d";
      context.font = '600 28px Montserrat, sans-serif';
      context.fillText("CRYSTAL HEALTH & BEAUTY", 120, height > 1400 ? 250 : 160);
      context.font = '600 22px Montserrat, sans-serif';
      context.fillText("YOUR BEAUTY PERSONALITY", 120, height > 1400 ? 360 : 240);
      context.fillStyle = "#67384f";
      context.font = '500 86px "Cormorant Garamond", Georgia, serif';
      var nameLines = wrap(context, current.person.name, width - 240);
      var y = height > 1400 ? 480 : 340;
      nameLines.forEach(function (line) {
        context.fillText(line, 120, y);
        y += 96;
      });
      context.fillStyle = "#30262b";
      context.font = '500 32px Montserrat, sans-serif';
      y += 20;
      wrap(context, current.person.description, width - 240).forEach(function (line) {
        context.fillText(line, 120, y);
        y += 46;
      });
      var shareY = Math.max(y + 80, height > 1400 ? 1280 : 760);
      context.fillStyle = "#b68b48";
      context.fillRect(120, shareY - 50, 160, 4);
      context.fillStyle = "#67384f";
      context.font = '500 40px "Cormorant Garamond", Georgia, serif';
      wrap(context, shareText(current.person), width - 240).forEach(function (line) {
        context.fillText(line, 120, shareY);
        shareY += 52;
      });
      context.fillStyle = "#93546d";
      context.font = '600 26px Montserrat, sans-serif';
      context.fillText("crystalhealthandbeauty.co.uk", 120, height - 120);
      return canvas;
    }

    function openImage(canvas, filename) {
      canvas.toBlob(function (blob) {
        if (!blob) { say("The image could not be created."); return; }
        var url = URL.createObjectURL(blob);
        if (dialogImg) {
          dialogImg.src = url;
          dialogImg.width = canvas.width;
          dialogImg.height = canvas.height;
          dialogImg.alt = (current.person.name || "Ritual") + " share image";
        }
        if (dialogLink) {
          dialogLink.href = url;
          dialogLink.download = filename;
          dialogLink.click();
        }
        if (dialog && typeof dialog.showModal === "function" && !dialog.open) dialog.showModal();
        say("Image ready. Save it, then add it to Instagram yourself.");
        track("beauty_ritual_shared", { ritual: current.person.slug, method: filename.indexOf("story") > -1 ? "story" : "square" });
      }, "image/png");
    }

    function prepareFonts() {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      return Promise.all([
        document.fonts.load('500 86px "Cormorant Garamond"'),
        document.fonts.load("600 28px Montserrat")
      ]).catch(function () {});
    }

    root.addEventListener("change", function (event) {
      var input = event.target;
      if (!input || !input.name) return;
      if (input.name === "mood" || input.name === "scent" || input.name === "moment") {
        state[input.name] = input.value;
        saveState();
      }
    });

    root.addEventListener("click", function (event) {
      var add = event.target.closest("[data-ritual-add]");
      if (add && root.contains(add)) {
        event.preventDefault();
        addToBasket(add);
        return;
      }
      var product = event.target.closest("[data-ritual-product]");
      if (product && root.contains(product) && current) {
        track("beauty_ritual_product_clicked", { ritual: current.person.slug, product: product.getAttribute("data-ritual-product") });
      }
    });

    function addToBasket(button) {
      var id = Number(button.getAttribute("data-variant-id"));
      var note = button.parentNode.querySelector("[data-ritual-add-note]");
      if (!id) return;
      var label = button.textContent;
      button.disabled = true;
      button.textContent = "Adding…";
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      if (rootPath.slice(-1) !== "/") rootPath += "/";
      fetch(rootPath + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      }).then(function () {
        if (note) note.textContent = "Added to basket.";
        say("Added to basket.");
        var opener = document.querySelector("[data-cart-open]");
        if (opener) opener.click();
      }).catch(function (error) {
        var message = (error && (error.description || error.message)) || "That product could not be added. It may be sold out.";
        if (note) note.textContent = message;
        say(message);
      }).then(function () {
        button.disabled = false;
        button.textContent = label;
      });
    }

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        goNext();
      });
    }
    var nextButton = root.querySelector("[data-ritual-next]");
    var restartButton = root.querySelector("[data-ritual-restart]");
    var takeButton = root.querySelector("[data-ritual-take]");
    var shareButton = root.querySelector("[data-ritual-share]");
    var copyButton = root.querySelector("[data-ritual-copy]");
    var storyButton = root.querySelector("[data-ritual-story]");
    var squareButton = root.querySelector("[data-ritual-square]");
    if (nextButton) nextButton.addEventListener("click", goNext);
    root.querySelectorAll("[data-ritual-back]").forEach(function (button) {
      button.addEventListener("click", goBack);
    });
    if (restartButton) restartButton.addEventListener("click", restart);
    if (takeButton) takeButton.addEventListener("click", function () {
      clearState();
      form.reset();
      writeUrl("");
      state.started = true;
      saveState();
      track("beauty_ritual_started", {});
      showQuestion(1, true);
    });
    if (shareButton) shareButton.addEventListener("click", function () {
      if (!current) return;
      var text = shareText(current.person);
      var url = shareUrl(current.person.slug);
      if (navigator.share) {
        navigator.share({ title: current.person.name, text: text, url: url }).then(function () {
          say("Share sheet opened.");
          track("beauty_ritual_shared", { ritual: current.person.slug, method: "share" });
        }).catch(function (error) {
          if (error && error.name === "AbortError") return;
          copyText(text + " " + url).then(function () {
            say("Link copied.");
            track("beauty_ritual_shared", { ritual: current.person.slug, method: "copy" });
          }).catch(function () { say("The link could not be copied."); });
        });
        return;
      }
      copyText(text + " " + url).then(function () {
        say("Link copied.");
        track("beauty_ritual_shared", { ritual: current.person.slug, method: "copy" });
      }).catch(function () { say("The link could not be copied."); });
    });
    if (copyButton) copyButton.addEventListener("click", function () {
      if (!current) return;
      copyText(messageFor(current.person)).then(function () {
        say("Result copied.");
        track("beauty_ritual_shared", { ritual: current.person.slug, method: "copy" });
      }).catch(function () { say("The result could not be copied."); });
    });
    function download(kind) {
      if (!current) return;
      prepareFonts().then(function () {
        var canvas = kind === "story" ? drawCard(1080, 1920) : drawCard(1080, 1080);
        openImage(canvas, "chb-" + current.person.slug + "-" + kind + ".png");
      });
    }
    if (storyButton) storyButton.addEventListener("click", function () { download("story"); });
    if (squareButton) squareButton.addEventListener("click", function () { download("square"); });

    if (inbox) {
      inbox.addEventListener("submit", function (event) {
        event.preventDefault();
        var email = (inbox.querySelector("[data-ritual-email]").value || "").trim();
        var consent = inbox.querySelector("[data-ritual-consent]");
        var note = inbox.querySelector("[data-ritual-inbox-note]");
        if (!consent.checked) {
          if (note) note.textContent = "Tick the box if you want this ritual by email.";
          consent.focus();
          return;
        }
        if (email.indexOf("@") < 1 || email.indexOf(".") < 0) {
          if (note) note.textContent = "Enter a valid email address.";
          return;
        }
        var company = config.company || "";
        var list = config.list || "";
        if (!company || !list) {
          if (note) note.textContent = "Email signup is not configured.";
          return;
        }
        var slug = current ? current.person.slug : "";
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company), {
          method: "POST",
          headers: { revision: "2025-10-15", "content-type": "application/vnd.api+json" },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Beauty Ritual Studio" + (slug ? ": " + slug : ""),
                profile: { data: { type: "profile", attributes: { email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } } } }
              },
              relationships: { list: { data: { type: "list", id: list } } }
            }
          })
        }).then(function (response) {
          if (!response.ok) throw new Error("status");
          if (note) note.textContent = "Saved. Watch your inbox.";
          inbox.reset();
        }).catch(function () {
          if (note) note.textContent = "That email could not be saved. You can still shop the ritual.";
        });
      });
    }

    ["mood", "scent", "moment"].forEach(function (key) { if (state[key]) setChecked(key, state[key]); });
    var requested = ritualParam();
    if (requested && bySlug[requested]) {
      var sharedPerson = bySlug[requested];
      var own = state.self && state.slug === requested;
      var moment = own && state.moment ? state.moment : "evening";
      if (own) {
        setChecked("mood", sharedPerson.mood);
        setChecked("scent", sharedPerson.scent);
        setChecked("moment", moment);
      }
      showResult(sharedPerson, moment, own ? "self" : "shared", false);
      return;
    }
    if (requested) say("That ritual link is not recognised. Take the quiz to find yours.");
    if (state.step === "result" && state.self && state.slug && bySlug[state.slug]) {
      showResult(bySlug[state.slug], state.moment || "evening", "self", false);
      return;
    }
    var start = state.step === 2 || state.step === 3 ? state.step : 1;
    showQuestion(start, false);
  }

  function bootAll() {
    document.querySelectorAll("[data-ritual-root]").forEach(boot);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootAll);
  else bootAll();
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector("[data-ritual-root]");
    if (root) boot(root);
  });
})();
